var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Input Example")]),_vm._v(" "),_c('input',{attrs:{"type":"text","placeholder":"test input"},domProps:{"value":_vm.inputVal},on:{"input":_vm.changeThis}}),_vm._v(" "),_c('h2',[_vm._v("\n    Value is: "),_c('span',[_vm._v(" "+_vm._s(_vm.inputVal)+" ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-319088aa","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/InputTest.vue
// module id = null
// module chunks = 